import { render, staticRenderFns } from "./carousel-indicator.vue?vue&type=template&id=2590ce93"
import script from "./carousel-indicator.vue?vue&type=script&lang=js"
export * from "./carousel-indicator.vue?vue&type=script&lang=js"
import style0 from "./carousel-indicator.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports